"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Carrier = _interopRequireWildcard(require("../Carrier"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _Text = _interopRequireDefault(require("../Text"));
var _Link = _interopRequireDefault(require("../Link"));
var _SectionTile = _interopRequireDefault(require("../SectionTile"));
var _utilities = _interopRequireDefault(require("../../utilities"));
var _constant = require("./constant");
var _JourneyDetailSegment = _interopRequireDefault(require("./JourneyDetailSegment.proptypes"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var StyledSegmentItemContainer = _styledComponents.default.div.withConfig({
  displayName: "JourneyDetailSegment__StyledSegmentItemContainer",
  componentId: "sc-1v9bayk-0"
})(["padding-bottom:", ";padding-left:5px;margin-left:10px;border-left:1px ", " #ccc;", " &:before{font-family:", ";font-weight:500;content:attr(data-time);left:-60px;position:absolute;display:block;", " ", "}&:after{font-family:", ";font-size:", ";content:attr(data-day);left:-60px;color:", ";position:absolute;display:block;top:21px;}", " .action{cursor:pointer;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.space.normal;
}, function (_ref2) {
  var isStopover = _ref2.isStopover;
  return isStopover ? 'dashed' : 'solid';
}, function (_ref3) {
  var isDetail = _ref3.isDetail,
    theme = _ref3.theme;
  return isDetail && "margin-bottom:".concat(theme.space.normal, ";");
}, function (_ref4) {
  var theme = _ref4.theme;
  return (// eslint-disable-next-line max-len
    "".concat(theme.fontFamily.default, ", 'Nunito Sans', -apple-system, '.SFNSText-Regular', 'San Francisco', BlinkMacSystemFont, 'Segoe UI',\n    'Helvetica Neue', Helvetica, Arial, sans-serif")
  );
}, function (_ref5) {
  var isDetail = _ref5.isDetail;
  return (
    // eslint-disable-next-line no-nested-ternary
    isDetail ? 'top: -15px;' : 'top: 0px;'
  );
}, function (_ref6) {
  var isDetail = _ref6.isDetail,
    theme = _ref6.theme;
  return isDetail && "font-size:".concat(theme.fontSize.XSmall, "; color: ").concat(theme.colors.greyDark);
}, function (_ref7) {
  var theme = _ref7.theme;
  return (// eslint-disable-next-line max-len
    "".concat(theme.fontFamily.default, ", 'Nunito Sans', -apple-system, '.SFNSText-Regular', 'San Francisco', BlinkMacSystemFont, 'Segoe UI',\n    'Helvetica Neue', Helvetica, Arial, sans-serif")
  );
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.fontSize.XSmall;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.greyDark;
}, function (_ref10) {
  var isLast = _ref10.isLast;
  return isLast && "&:last-child {\n    display: flex;\n    align-items: flex-end;\n    padding-bottom: 0px;\n    border-left: none;\n    div {\n      padding-bottom: 0;\n    }\n  }";
});
var StyledSegmentItemIconContainer = _styledComponents.default.div.withConfig({
  displayName: "JourneyDetailSegment__StyledSegmentItemIconContainer",
  componentId: "sc-1v9bayk-1"
})(["position:absolute;background:#fff;height:23px;width:23px;display:flex;align-items:center;justify-content:center;left:-1px;top:-2px;"]);
var StyledSegmentItemDetails = _styledComponents.default.div.withConfig({
  displayName: "JourneyDetailSegment__StyledSegmentItemDetails",
  componentId: "sc-1v9bayk-2"
})(["padding:", ";background-color:", ";border-radius:", ";display:flex;flex-direction:column;margin-left:-75px;"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.space.medium;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.greyLighter;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.borderRadius.small;
});
var StyledFlexDiv = _styledComponents.default.div.withConfig({
  displayName: "JourneyDetailSegment__StyledFlexDiv",
  componentId: "sc-1v9bayk-3"
})(["display:flex;align-items:center;"]);
var convertUtcToGmt = function convertUtcToGmt(utcDate) {
  var useLocalTimezone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var dateObj = new Date(utcDate);
  // new Date converts utcDate to local timezone
  // if useLocalTimezone is true
  // return and use dateObj which is already using client's browser timezone
  if (useLocalTimezone) {
    return dateObj;
  }
  var gmtDate = new Date(dateObj.getUTCFullYear(), dateObj.getUTCMonth(), dateObj.getUTCDate(), dateObj.getUTCHours(), dateObj.getUTCMinutes(), dateObj.getUTCSeconds(), dateObj.getUTCMilliseconds());
  return gmtDate;
};
var convertSecToHr = function convertSecToHr(seconds) {
  var hrs = seconds / 3600;
  var hour = Math.floor(hrs);
  var minute = Math.round((hrs - hour) * 60);
  return {
    hour: hour,
    minute: minute
  };
};

/** This function will calculate and render the duration */
var renderDuration = function renderDuration(hourCycle, designator, isTo, locale, useLocalTimezone) {
  return "".concat(new Date(!isTo ? convertUtcToGmt(designator.departureTime, useLocalTimezone) : convertUtcToGmt(designator.arrivalTime, useLocalTimezone)).toLocaleTimeString(locale, {
    hour: '2-digit',
    minute: '2-digit',
    hour12: hourCycle !== 24
  }));
};
var renderDateMonth = function renderDateMonth(designator, isTo, useLocalTimezone, language) {
  var unifiedConfirmationPageProp = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var locale = arguments.length > 5 ? arguments[5] : undefined;
  if (!unifiedConfirmationPageProp) {
    return "".concat((!isTo ? convertUtcToGmt(designator.departureTime, useLocalTimezone) : convertUtcToGmt(designator.arrivalTime, useLocalTimezone)).toLocaleDateString(locale, {
      month: 'short',
      day: '2-digit'
    }));
  }
  var date = isTo ? convertUtcToGmt(designator.arrivalTime, useLocalTimezone) : convertUtcToGmt(designator.departureTime, useLocalTimezone);
  var month = date.toLocaleString(locale, {
    month: 'short'
  });
  var day = date.getDate();
  return "".concat(day, " ").concat(month);
};
var JourneyDetailSegment = function JourneyDetailSegment(_ref14) {
  var accessible = _ref14.accessible,
    customProperties = _ref14.customProperties,
    theme = _ref14.theme,
    segment = _ref14.segment,
    isLast = _ref14.isLast,
    _ref14$isStopover = _ref14.isStopover,
    isStopover = _ref14$isStopover === void 0 ? false : _ref14$isStopover,
    isSelfTransfer = _ref14.isSelfTransfer,
    isProtected = _ref14.isProtected,
    protectedBy = _ref14.protectedBy,
    protectedByAction = _ref14.protectedByAction,
    translation = _ref14.translation,
    linkVoid = _ref14.linkVoid,
    isTechnicalStop = _ref14.isTechnicalStop,
    technicalStopLabel = _ref14.technicalStopLabel,
    locale = _ref14.locale,
    hourCycle = _ref14.hourCycle,
    isMobile = _ref14.isMobile,
    useLocalTimezone = _ref14.useLocalTimezone,
    unifiedConfirmationPageProp = _ref14.unifiedConfirmationPageProp,
    guest = _ref14.guest;
  var innerWidth = function innerWidth() {
    return typeof window !== 'undefined' ? window.innerWidth : 300;
  };
  var _React$useState = _react.default.useState(innerWidth()),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    windowWidth = _React$useState2[0],
    setWindowWidth = _React$useState2[1];
  /* istanbul ignore next */
  _react.default.useEffect(function () {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', function () {
        return setWindowWidth(innerWidth());
      });
    }
    return function () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', function () {
          return setWindowWidth(innerWidth());
        });
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var language = _objectSpread(_objectSpread({}, _constant.TRANSLATION), translation);
  var _segment$designator = segment.designator,
    arrivalTerminal = _segment$designator.arrivalTerminal,
    departureTerminal = _segment$designator.departureTerminal,
    _segment$designator$d = _segment$designator.duration,
    duration = _segment$designator$d === void 0 ? null : _segment$designator$d;
  var _convertSecToHr = convertSecToHr(segment.layoverTime),
    hour = _convertSecToHr.hour,
    minute = _convertSecToHr.minute;
  var isBusFerry = segment.isBusFerry,
    busFerryLabel = segment.busFerryLabel;
  var getLinkDetails = function getLinkDetails(selfTransferText, airportName) {
    return selfTransferText.includes('{0}') ? selfTransferText.replace('{0}', airportName) : selfTransferText.concat(' ', airportName);
  };
  var renderSelfTransferContent = function renderSelfTransferContent() {
    var _segment$designator2;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
      style: {
        color: _constant.COLORS.black
      }
    }, "".concat(language.selfTransferVia, " ").concat(((_segment$designator2 = segment.designator) === null || _segment$designator2 === void 0 ? void 0 : _segment$designator2.departureAirport) || language.departureAirport, ".")), /*#__PURE__*/_react.default.createElement("a", {
      href: language.moreInfoLink,
      target: "_blank",
      rel: "noopener noreferrer",
      style: {
        color: _constant.COLORS.tertiaryRed,
        textDecoration: 'none'
      }
    }, language.moreinfo), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        margin: '4px',
        textAlign: 'left'
      }
    }, /*#__PURE__*/_react.default.createElement("p", {
      style: {
        margin: '0 0 4px',
        fontWeight: 'bold'
      }
    }, language.heading), [language.selfTransferNote1, language.selfTransferNote2, language.selfTransferNote3, language.selfTransferNote4].map(function (note, index) {
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/no-array-index-key
        _react.default.createElement("p", {
          key: index,
          style: {
            margin: '0 0 5px'
          }
        }, note)
      );
    })));
  };
  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(StyledSegmentItemContainer, (0, _extends2.default)({
    tabIndex: !accessible ? '-1' : '0'
  }, customProperties, {
    "data-time": duration || renderDuration(hourCycle, segment.designator, isLast, locale, useLocalTimezone),
    "data-day": renderDateMonth(segment.designator, isLast, useLocalTimezone, language, unifiedConfirmationPageProp, locale)
  }, isStopover ? {
    isStopover: isStopover
  } : {
    isLast: isLast
  }), /*#__PURE__*/_react.default.createElement(StyledSegmentItemIconContainer, isStopover ? {
    isStopover: isStopover
  } : {
    isLast: isLast
  }, isStopover ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
    accessible: accessible,
    color: _constant.COLORS.greyDark,
    fontsize: _constant.SIZES.XSmall,
    icon: _constant.ICONS.destination,
    theme: theme
  }) : isLast ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
    accessible: accessible,
    color: _constant.COLORS.tertiaryRed,
    fontsize: _constant.SIZES.normal,
    icon: _constant.ICONS.stopover,
    theme: theme
  }) : isBusFerry ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
    accessible: accessible,
    color: _constant.COLORS.greyDark,
    fontsize: _constant.SIZES.normal,
    icon: _constant.ICONS.ferry,
    theme: theme
  }) : /*#__PURE__*/_react.default.createElement(_Icon.default, {
    accessible: accessible,
    color: _constant.COLORS.greyDark,
    fontsize: _constant.SIZES.normal,
    icon: _constant.ICONS.origin,
    theme: theme
  })), /*#__PURE__*/_react.default.createElement(_SectionTile.default, {
    accessible: accessible,
    active: false,
    hoverBackgroundColor: "default",
    title: isLast ? segment.designator.arrivalStation : segment.designator.departureStation,
    subtitle: isLast ? "".concat(segment.designator.arrivalAirport).concat(arrivalTerminal ? ", ".concat(arrivalTerminal) : '') : "".concat(segment.designator.departureAirport).concat(departureTerminal ? ", ".concat(departureTerminal) : ''),
    subtitleColor: _constant.COLORS.greyDark,
    theme: theme,
    titleColor: _constant.COLORS.neutral,
    subtitleType: _constant.SIZES.sub,
    activeBorderColor: "default",
    defaultBorderColor: "default",
    customProperties: {
      style: {
        paddingTop: 0
      }
    },
    value: ""
  }), isStopover && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledSegmentItemDetails, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
    accessible: accessible,
    color: _constant.COLORS.greyDark,
    display: _constant.DISPLAYS.inlineFlex,
    theme: theme,
    type: "sub",
    verticalAlign: "center"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    accessible: accessible,
    color: _constant.COLORS.greyDark,
    fontsize: _constant.SIZES.small,
    icon: _constant.ICONS.layover,
    theme: theme,
    customProperties: {
      style: {
        marginRight: 10
      }
    }
  }), language.layover, ":", " ", _utilities.default.constructDuration(hour, minute, language)), isSelfTransfer && !isTechnicalStop && /*#__PURE__*/_react.default.createElement(_Text.default, {
    accessible: true,
    color: _constant.COLORS.greyDark,
    display: (0, _Carrier.setBreakpoint)(windowWidth) ? _constant.DISPLAYS.block : _constant.DISPLAYS.inlineFlex,
    verticalAlign: "center",
    theme: theme,
    type: "sub",
    marginBottom: "8px" // Adjust the margin bottom as needed
  }, /*#__PURE__*/_react.default.createElement(StyledFlexDiv, null, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    accessible: accessible,
    color: _constant.COLORS.greyDark,
    fontsize: _constant.SIZES.small,
    icon: _constant.ICONS.selfTransfer,
    theme: theme,
    customProperties: {
      style: {
        marginRight: 10
      }
    }
  }), renderSelfTransferContent()))), isTechnicalStop && /*#__PURE__*/_react.default.createElement(_Text.default, {
    accessible: accessible,
    color: _constant.COLORS.greyDark,
    display: (0, _Carrier.setBreakpoint)(windowWidth) ? _constant.DISPLAYS.block : _constant.DISPLAYS.inlineFlex,
    verticalAlign: "center",
    theme: theme,
    type: "sub"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    accessible: accessible,
    color: _constant.COLORS.greyDark,
    fontsize: _constant.SIZES.small,
    icon: _constant.ICONS.technicalStop,
    theme: theme,
    customProperties: {
      style: {
        marginRight: 10
      }
    }
  }), technicalStopLabel), isProtected && !isTechnicalStop && /*#__PURE__*/_react.default.createElement(_Text.default, {
    accessible: accessible,
    color: _constant.COLORS.greyDark,
    display: (0, _Carrier.setBreakpoint)(windowWidth) ? _constant.DISPLAYS.block : _constant.DISPLAYS.inlineFlex,
    verticalAlign: "center",
    theme: theme,
    type: "sub"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    accessible: accessible,
    color: _constant.COLORS.greyDark,
    fontsize: _constant.SIZES.small,
    icon: _constant.ICONS.protectedBy,
    theme: theme,
    customProperties: {
      style: {
        marginRight: 10
      }
    }
  }), /*#__PURE__*/_react.default.createElement(_Link.default, {
    accessible: accessible,
    color: _constant.COLORS.orange,
    theme: theme,
    size: _constant.SIZES.small,
    href: linkVoid,
    target: "callback",
    callback: protectedByAction,
    hoverUnderlined: false,
    customProperties: {
      className: 'action',
      id: segment.airlineProfile,
      style: {
        marginLeft: 3
      }
    }
  }, getLinkDetails(language.protectionByStr, protectedBy || language.carrier))))), !isLast && !isStopover && /*#__PURE__*/_react.default.createElement(_Carrier.default, {
    accessible: accessible,
    theme: theme,
    carrierLogoSize: _constant.SIZES.small,
    carrier: segment.carrier,
    designator: segment.designator,
    translation: language,
    duration: segment.duration,
    isMobile: isMobile,
    isBusFerry: isBusFerry,
    busFerryLabel: busFerryLabel,
    language: language,
    guest: guest
  })));
};
JourneyDetailSegment.propTypes = _JourneyDetailSegment.default.PropTypes;
JourneyDetailSegment.defaultProps = _JourneyDetailSegment.default.DefaultProps;
var _default = JourneyDetailSegment;
exports.default = _default;